import { render, staticRenderFns } from "./Notaenfermeria.vue?vue&type=template&id=7210871a"
import script from "./Notaenfermeria.vue?vue&type=script&lang=js"
export * from "./Notaenfermeria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports